import { ListViewProvider, useListView } from '../core/ListViewProvider'
import { QueryRequestProvider } from '../core/QueryRequestProvider'
import { QueryResponseProvider, useQueryResponseData } from '../core/QueryResponseProvider'
import { UsersListHeader } from '../components/header/UsersListHeader'
import { UsersTable } from '../table/UsersTable'
import { UserEditModal } from '../form-edit-modal/CoomonEditModal'
import { KTCard } from '../../../../../../_metronic/helpers'
import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
import { roleColumns } from './_columns'
import { useAuth } from '../../../../auth'
import { useEffect, useState } from 'react'

const UsersList = () => {
  const { isPartner, isSupplyChainManager, isFacilityManager, currentUser } = useAuth()
  const isMarketingUser = (currentUser as any)?.userType === 'CLIENT_USER' || (currentUser as any)?.userType === 'MARKETING';
  const response = useQueryResponseData();
  console.log("response", response)
  // const scriptId = 'google-maps-script'
  // const scriptSrc =
  //   'https://maps.googleapis.com/maps/api/js?key=AIzaSyD32soTrhrAXzmKQp7rH8NsL8NQMhmdqlY&libraries=places'

  // useEffect(() => {
  //   // Function to load the script
  //   const loadScript = (): void => {
  //     if (!document.getElementById(scriptId)) {
  //       const script = document.createElement('script')
  //       script.id = scriptId
  //       script.src = scriptSrc
  //       script.async = true
  //       script.defer = true
  //       document.body.appendChild(script)
  //     }
  //   }

  //   // Function to remove the script
  //   const removeScript = (): void => {
  //     const script = document.getElementById(scriptId)
  //     if (script && script.parentNode) {
  //       script.parentNode.removeChild(script)
  //     }
  //   }

  //   loadScript()

  //   // Cleanup function to remove the script when the component unmounts
  //   return () => {
  //     removeScript()
  //   }
  // }, [scriptSrc])


  const SearchIcon = () => (
    <svg
      width='16'
      height='16'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      style={{
        position: 'absolute',
        left: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        color: '#6B7280',
      }}
    >
      <circle cx='11' cy='11' r='8' />
      <line x1='21' y1='21' x2='16.65' y2='16.65' />
    </svg>
  )

  const [searchQuery, setSearchQuery] = useState('')
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value.toLowerCase()
    setSearchQuery(query)

    // Get all table rows
    const tableRows = document.querySelectorAll('table tbody tr') as NodeListOf<HTMLTableRowElement>

    // Loop through each row
    tableRows.forEach((row: HTMLTableRowElement) => {
      const cells = row.querySelectorAll('td') as NodeListOf<HTMLTableCellElement>
      let found = false

      // Check each cell in the row
      cells.forEach((cell: HTMLTableCellElement) => {
        const text = cell.textContent?.toLowerCase() || ''
        if (text.includes(query)) {
          found = true
        }
      })

      // Show/hide row based on search match
      if (found) {
        row.style.display = ''
      } else {
        row.style.display = 'none'
      }
    })
  }


  return (
    <KTCard>
      {/* {!isPartner && <UsersListHeader placeholder='Search name' label='Add new' />} */}
      {/* <div
        style={{
          position: 'relative',
          width: '300px',
          marginLeft: '30px',
          marginBottom: '-30px',
        }}
      >
        <SearchIcon />
        <input
          type='text'
          placeholder='Search users...'
          value={searchQuery}
          onChange={handleSearch}
          style={{
            width: '100%',
            height: '40px',
            padding: '8px 8px 8px 35px',
            fontSize: '14px',
            border: '1px solid #E5E7EB',
            borderRadius: '6px',
            outline: 'none',
            backgroundColor: 'white',
            transition: 'border-color 0.2s ease',
          }}
          onFocus={(e) => (e.target.style.borderColor = '#3B82F6')}
          onBlur={(e) => (e.target.style.borderColor = '#E5E7EB')}
        />
      </div>
      {!isPartner && !isFacilityManager && <UsersListHeader placeholder='Search name' label='Add new' />} */}




      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 30px"
      }}>
        <div
          style={{
            position: 'relative',
            width: '300px',
          }}
        >
          <SearchIcon />
          <input
            type='text'
            placeholder='Search users...'
            value={searchQuery}
            onChange={handleSearch}
            style={{
              width: '100%',
              height: '40px',
              padding: '8px 8px 8px 35px',
              fontSize: '14px',
              border: '1px solid #E5E7EB',
              borderRadius: '6px',
              outline: 'none',
              backgroundColor: 'white',
              transition: 'border-color 0.2s ease',
            }}
            onFocus={(e) => (e.target.style.borderColor = '#3B82F6')}
            onBlur={(e) => (e.target.style.borderColor = '#E5E7EB')}
          />
        </div>
        {/* <div>
          {!isPartner && !isFacilityManager && <UsersListHeader placeholder='Search name' label='Add new' />}
        </div> */}
        <div>
          {!isPartner && !isFacilityManager && !isMarketingUser && <UsersListHeader placeholder='Search name' label='Add new' />}
        </div>
      </div>

      {/* Metrics Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px', padding: '10px 30px' }}>

        {/* Card 1 */}
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
          <div style={{ backgroundColor: '#FFE500', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 11C14.7614 11 17 8.76142 17 6C17 3.23858 14.7614 1 12 1C9.23858 1 7 3.23858 7 6C7 8.76142 9.23858 11 12 11Z" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M2 22C2 17.5817 6.47715 14 12 14C17.5228 14 22 17.5817 22 22" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div>
            <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Total Material Hubs</div>
            <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>{response?.length}</div>
            <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>All time</div>
          </div>
        </div>

        {/* Card 2 */}
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
          <div style={{ backgroundColor: '#000000', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="9" cy="8" r="3.5"
                stroke="#ffffff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />

              <path d="M3.5 19C4.2 15.7 6.1 14 9 14C11.9 14 13.8 15.7 14.5 19"
                stroke="#ffffff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />

              <path d="M15 16.5L17 18.5L21 14.5"
                stroke="#FFFFFF"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
          <div>
            <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Active Material Hubs</div>
            <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>{response?.filter((item: any) => item.active).length}</div>
            <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>{((response?.filter((item: any) => item.active).length) / (response?.length) * 100).toFixed(2)}% of total</div>
          </div>
        </div>

        {/* Card 3 */}
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
          <div style={{ backgroundColor: '#FFE500', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="8" r="3.5"
                stroke="#000000"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />

              <path d="M5 19C5.8 15.7 8.3 14 12 14C15.7 14 18.2 15.7 19 19"
                stroke="#000000"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />

              <circle cx="18.5" cy="18" r="3"
                fill="#000000"
                stroke="#000000"
                stroke-width="1.5" />
            </svg>
          </div>
          <div>
            <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Inactive Material Hubs</div>
            <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>{response?.filter((item: any) => !item.active).length}</div>
            <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>{((response?.filter((item: any) => !item.active).length) / (response?.length) * 100).toFixed(2)}% of total</div>
          </div>
        </div>

        {/* Card 4 */}
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
          <div style={{ backgroundColor: '#000000', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="8" width="18" height="13" rx="2" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12 8V21" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12 8V5C12 3.89543 11.1046 3 10 3C8.89543 3 8 3.89543 8 5C8 6.65685 9.34315 8 11 8H12ZM12 8V5C12 3.89543 12.8954 3 14 3C15.1046 3 16 3.89543 16 5C16 6.65685 14.6569 8 13 8H12Z" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div>
            <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Volume handled</div>
            <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>{response?.reduce((acc, cur) => acc + cur?.lifeTimePerformance, 0)?.toLocaleString("en", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}</div>
            <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>Lifetime</div>
          </div>
        </div>

      </div>


      <UsersTable columnProps={roleColumns(isPartner, isSupplyChainManager, isFacilityManager, isMarketingUser)} />


      {<UserEditModal formName='FacilitiesModalForm' />}
    </KTCard>
  )
}





const UserIncentiveWrapper = () => {
  const getFranchiseId = () => {
    const authData = localStorage.getItem('kt-auth-react-v');
    if (authData) {
      try {
        const parsedData = JSON.parse(authData);
        const id = parsedData.data?.franchises?.[0]?.id || '';
        // console.log("1️⃣ getFranchiseId extracted:", id);
        return id;
      } catch (e) {
        console.error('Error parsing auth data:', e);
        return '';
      }
    }
    return '';
  };

  const franchiseId = getFranchiseId();
  // console.log("2️⃣ franchiseId being passed to QueryRequestProvider:", franchiseId);

  return (
    <QueryRequestProvider
      initialValue={{
        type: 'PICKUP_POINT',
        facilityType: 'COLLECTION_TYPE,MRF,AGGREGATOR,DIVERSION_FACILITY',
        franchiseId: franchiseId
      }}
    >
      <QueryResponseProvider>
        <ListViewProvider>
          <UsersList />
        </ListViewProvider>
      </QueryResponseProvider>
    </QueryRequestProvider>
  )
}

export { UserIncentiveWrapper }


